module.exports = __webpack_public_path__ + "img/chapelhill-logo.006df897.png";